import { RequireOnly } from '@pelicargo/types';
import { formatAwbLabel, modelUtils } from '@pelicargo/utils';
import { Document, ShipmentForm } from '@prisma/client';

type LabelableShipmentForm = RequireOnly<ShipmentForm, 'id' | 'parent_shipment_form_id'> & {
  documents?: RequireOnly<Document, 'id'>[];
};

/**
 * Airway bills belong to a specific shipment form: the MAWB (no parent) or one
 * of its HAWBs. Build a lookup from document id to its "MAWB" / "HAWB n" tag so
 * document lists can tell otherwise-identical "Airway Bill" rows apart. HAWBs
 * are numbered in the same order the paperwork UI lists them.
 */
export const buildAwbDocumentLabels = (shipmentForms?: LabelableShipmentForm[]): Record<number, string> => {
  const labels: Record<number, string> = {};

  modelUtils.shipmentForms.orderMawbFirst(shipmentForms).forEach((form, index) => {
    form.documents?.forEach((doc) => {
      labels[doc.id] = formatAwbLabel(index);
    });
  });

  return labels;
};
